import { useReportStore, Violation } from '@/stores/ReportStore';
import React, { createContext, ReactNode, useContext } from 'react';

interface ReportProviderProps {
  children: ReactNode;
  isWeb: boolean;
}

interface ReportContextProps {
  violations: Violation[];
  addViolation: (violation: Violation) => void;
  removeViolation: (id: string) => void;
  clearViolations: () => void;
}

const ReportContext = createContext<ReportContextProps | undefined>(undefined);

export const useReportContext = () => {
  const context = useContext(ReportContext);
  if (!context) {
    throw new Error('useReportContext must be used within a ReportProvider');
  }
  return context;
};

const ReportProvider: React.FC<ReportProviderProps> = ({ children, isWeb }) => {
  const { violations, addViolation, removeViolation, clearViolations } =
    useReportStore();

  // useEffect(() => {
  //   // const fetchViolationFromChromeStorage = async () => {
  //   //   return await getLocalStorageDataByKey('violation');
  //   // };
  //
  //   if (isWeb) {
  //     // TODO from API
  //   } else {
  //     // fetchViolationFromChromeStorage().then((data: any) => {
  //     //   addViolation(data as Violation);
  //     // });
  //   }
  // }, [isWeb]);

  return (
    <ReportContext.Provider
      value={{ violations, addViolation, removeViolation, clearViolations }}
    >
      {children}
    </ReportContext.Provider>
  );
};

export { ReportProvider };
